<template>
  <div class="nav-sections">
    <button
      v-for="(section, key) in sections"
      :key="key"
      class="nav-sections__button"
      :class="{ _active: key === activeSectionKey }"
      :disabled="section.disabled"
      :title="section.title"
      @click="onButtonClick(key)"
    >
      <svg width="30" height="30">
        <use :xlink:href="section.icon" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Object,
      required: true
    },

    activeSectionKey: {
      type: String,
      required: true
    }
  },

  methods: {
    onButtonClick(sectionKey) {
      this.$emit('button-click', sectionKey);
    }
  }
};
</script>
